import { Pipe } from '@angular/core';

@Pipe({name: 'isEmpty'})
export class isEmptyPipe {
  transform(value){
  		if(value == null || value == undefined)
			return "N/A";
		else return value;
	}
}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/pipes/isEmpty.pipe.ts